export const START_TOUR = 'START_TOUR'

export const END_TOUR = 'END_TOUR'

export const CLOSE_TOUR_BUTTON_CLICKED = 'CLOSE_TOUR_BUTTON_CLICKED'

export const OPEN_END_TOUR_MODAL = 'OPEN_END_TOUR_MODAL'

export function toggleTourOn() {
  return {
    type: START_TOUR
  }
}

export function toggleTourOff() {
  return {
    type: END_TOUR
  }
}

export function openEndTourModal() {
  return {
    type: OPEN_END_TOUR_MODAL
  }
}

export function closeTourButtonClicked() {
  return {
    type: CLOSE_TOUR_BUTTON_CLICKED
  }
}


// WEBPACK FOOTER //
// ./src/redux/actions/toggleTourActions.js